/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Intake_Why_Sex_ShortInputs */

const en_us2_intake_why_sex_short = /** @type {(inputs: Intake_Why_Sex_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Used for the load estimates`)
};

const pt_br2_intake_why_sex_short = /** @type {(inputs: Intake_Why_Sex_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Usado nas estimativas de carga`)
};

const es_419_intake_why_sex_short = /** @type {(inputs: Intake_Why_Sex_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Se usa para estimar las cargas`)
};

const pt_pt2_intake_why_sex_short = /** @type {(inputs: Intake_Why_Sex_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Usado nas estimativas de carga`)
};

const fr_fr2_intake_why_sex_short = /** @type {(inputs: Intake_Why_Sex_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sert aux estimations de charge`)
};

const de_de2_intake_why_sex_short = /** @type {(inputs: Intake_Why_Sex_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Für die Gewichtsschätzungen`)
};

const it_it2_intake_why_sex_short = /** @type {(inputs: Intake_Why_Sex_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Serve per stimare i carichi`)
};

/**
* | output |
* | --- |
* | "Used for the load estimates" |
*
* @param {Intake_Why_Sex_ShortInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const intake_why_sex_short = /** @type {((inputs?: Intake_Why_Sex_ShortInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Intake_Why_Sex_ShortInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_intake_why_sex_short(inputs)
	if (locale === "es-419") return es_419_intake_why_sex_short(inputs)
	if (locale === "pt-PT") return pt_pt2_intake_why_sex_short(inputs)
	if (locale === "fr-FR") return fr_fr2_intake_why_sex_short(inputs)
	if (locale === "de-DE") return de_de2_intake_why_sex_short(inputs)
	if (locale === "it-IT") return it_it2_intake_why_sex_short(inputs)
	return en_us2_intake_why_sex_short(inputs)
});
export { intake_why_sex_short as "intake.why.sex.short" }